import { useQuery } from '@tanstack/react-query';

import { partnerInvitesApi, partnerInvitesApiKeys } from '@/api/routes/public/partnerInvites.api';

/** The invite behind `/invite/:token`, readable signed out. */
export const usePartnerInvitePreview = (token?: string) => {
  return useQuery({
    queryKey: partnerInvitesApiKeys.preview(token ?? ''),
    queryFn: () => partnerInvitesApi.preview(token as string).then((res) => res.data),
    enabled: Boolean(token),
  });
};
